import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-loader',
  imports:[MatProgressSpinner, CommonModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})

export class LoaderComponent implements OnInit {
  loading$!: Observable<boolean>;

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loading$ = this.loaderService.loading$;
  }
}
